<template>
  <div :id="anchor" v-editable="blok">
    <RichTextRenderer :document="richTextContent" />
  </div>
</template>

<script setup lang="ts">
import type { BlockRichTextSimpleStoryblok } from '~/types/storyblok'

const props = defineProps<{
  blok: BlockRichTextSimpleStoryblok
}>()
const { richTextContent } = useStoryContent(toRefs(props))
const anchor = computed(() => props.blok.anchor)
</script>
